// src/pages/SpecialOffers/CategoryTabs.js

import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import {
  Box,
  Button,
  Menu,
  MenuItem,
  Tab,
  Tabs,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useEffect, useRef, useState } from "react";
import LiquidGlass from "../../LiquidGlass";

const CategoryTabs = ({
  categories,
  selectedCategory,
  onCategoryChange,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const tabsRef = useRef(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [indicatorStyle, setIndicatorStyle] = useState({ left: 0, width: 0 });

  

  const tabSx = {
    mb: 2,
    border: "1px solid grey.200",
    borderRadius: "16px",
    bgcolor: "grey.50",
    display: isMobile ? "none" : "flex",
    position: "relative",
    "& .MuiTabs-flexContainer": {
      flexWrap: "nowrap",
      gap: 1,
      p: 0.5,
      position: "relative",
      zIndex: 1,
    },
    "& .MuiTab-root": {
      flex: 1,
      minWidth: 0,
      textOverflow: "ellipsis",
      overflow: "hidden",
      whiteSpace: "nowrap",
      borderRadius: "16px",
      bgcolor: "transparent",
      color: "text.primary",
      "&.Mui-selected": { color: "#fff" },
      "&:hover": { bgcolor: "primary.light", color: "#fff" },
      py: 0.3,
      fontSize: { xs: "0.7rem", sm: "0.75rem", md: "0.8rem" },
      zIndex: 2,
    },
    "& .MuiTabs-indicator": { display: "none" },
  };

  const menuButtonSx = {
    mb: 0,
    display: isMobile ? "flex" : "none",
    width: "100%",
    boxSizing: "border-box",
    borderRadius: "6px",
    textTransform: "none",
    flexDirection: "column",
    alignItems: "flex-start",
  };

  const handleMenuOpen = (e) => setAnchorEl(e.currentTarget);
  const handleMenuClose = () => setAnchorEl(null);
  const handleChange = (_, newValue) => {
    onCategoryChange(newValue);
    handleMenuClose();
  };

  // Reposition the sliding pill under the selected tab
  useEffect(() => {
    if (!isMobile && tabsRef.current) {
      const tabs = tabsRef.current.querySelectorAll(".MuiTab-root");
      const idx = categories.indexOf(selectedCategory);
      if (tabs[idx]) {
        const { offsetLeft, offsetWidth } = tabs[idx];
        setIndicatorStyle({ left: offsetLeft, width: offsetWidth });
      }
    }
  }, [selectedCategory, categories, isMobile]);

  return (
     <LiquidGlass>
        {/* Mobile dropdown */}
        <Button
          onClick={handleMenuOpen}
          sx={menuButtonSx}
          aria-controls={anchorEl ? "category-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={Boolean(anchorEl)}
        >
          <Typography
            sx={{ fontSize: "0.75rem", mb: 0.2, color: "#fff", fontWeight: 600 }}
          >
            Select A Category Below:
          </Typography>
          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography
              sx={{
                fontSize: "0.85rem",
                color: "#fff",
                textShadow: "0px 1px 2px rgba(0,0,0,0.5)",
              }}
            >
              {selectedCategory
                .split("-")
                .map((w) => w[0].toUpperCase() + w.slice(1))
                .join(" ")}
            </Typography>
            <ArrowDropDownIcon sx={{ color: "#fff" }} />
          </Box>
        </Button>

        <Menu
          id="category-menu"
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
          transformOrigin={{ vertical: "top", horizontal: "left" }}
          sx={{
            "& .MuiPaper-root": {
              width: anchorEl ? anchorEl.offsetWidth : "100%",
              maxWidth: "100%",
              boxSizing: "border-box",
              borderRadius: "6px",
              left: anchorEl ? anchorEl.getBoundingClientRect().left : 0,
            },
          }}
        >
          {categories.map((cat) => (
            <MenuItem
              key={cat}
              value={cat}
              onClick={() => handleChange(null, cat)}
              sx={{ fontSize: "0.85rem" }}
            >
              {cat
                .split("-")
                .map((w) => w[0].toUpperCase() + w.slice(1))
                .join(" ")}
            </MenuItem>
          ))}
        </Menu>

        {/* Desktop tabs */}
        <Tabs
          value={selectedCategory}
          onChange={handleChange}
          variant="standard"
          scrollButtons={false}
          sx={tabSx}
          orientation="horizontal"
          ref={tabsRef}
        >
          {categories.map((cat) => (
            <Tab
              key={cat}
              value={cat}
              label={cat.replace(/-/g, " ")}
              sx={{ textTransform: "capitalize", fontWeight: 500 }}
            />
          ))}
          <Box
            sx={{
              position: "absolute",
              top: 4,
              height: "calc(100% - 8px)",
              bgcolor: "primary.main",
              borderRadius: "16px",
              transition: "left 0.3s, width 0.6s",
              zIndex: 1,
              ...indicatorStyle,
            }}
          />
        </Tabs>
      </LiquidGlass>
  );
};

export default CategoryTabs;